import { render, staticRenderFns } from "./eventPreviewComponent.vue?vue&type=template&id=23212f1d&scoped=true&"
import script from "./eventPreviewComponent.vue?vue&type=script&lang=ts&"
export * from "./eventPreviewComponent.vue?vue&type=script&lang=ts&"
import style0 from "./eventPreviewComponent.vue?vue&type=style&index=0&id=23212f1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23212f1d",
  null
  
)

export default component.exports